<template>
  <div style="display: flex; flex-direction: column">
    <div class="btn">
      <el-button
        v-if="canAdd"
        type="primary"
        @click="_modify(null)"
      >新增</el-button>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        style="height: 100%"
      >
        <el-table-column prop="fName" label="仓库名称" />
        <!-- <el-table-column prop="fScale" label="小数位">
      </el-table-column> -->
        <el-table-column prop="fCreater" label="添加人" />
        <el-table-column
          prop="fCreateTime"
          label="添加时间"
          :formatter="dateFormat"
        />

        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <el-button
                type="text"
                size="small"
                @click="_modify(scope.row)"
              >查看</el-button>
            </template>
            <template>
              <ConfirmButton
                v-if="delState"
                @confirm="_delete(scope.row)"
              >删除</ConfirmButton>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

import ConfirmButton from '@components/ConfirmButton'
import editForm from './editForm'

export default {
  components: {
    ConfirmButton,
    editForm
  },
  data() {
    return {
      tableData: [],
      loading: false,
      currentEditItem: null,

      canAdd: true,
      canEdit: true,
      delState: true,
      authorityState: true,
      roleState: true
    }
  },
  mounted() {
    this.refresh()
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '003001002') {
        this.canAdd = val.isGrant
      }
      if (val.key == '003001003') {
        this.canEdit = val.isGrant
      }
      if (val.key == '003001004') {
        this.delState = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('Warehouse/Stock/StockEntry', {}).then((res) => {
        // console.log(res, 'res')
        this.tableData = res.datalist
      })
        .finally(() => this.loading = false)
    },
    _modify: async function(row) {
      // console.log(row, 'row')
      const isNew = !row
      if (isNew) {
        this.currentEditItem = {
          fStockID: null,
          fName: '',
          fDes: '',
          fCreater: '',
          fCreateTime: '',
          fModify: '',
          fModifyTime: '',
          fModifyTimestamp: ''
        }
      } else {
        this.currentEditItem = await this.$httpPost(
          'Warehouse/Stock/GetStock',
          { fid: row.fStockID }
        ).then((res) => res.datalist)
        this.currentEditItem['fCreateTime'] = moment(
          this.currentEditItem['fCreateTime']
        ).format('YYYY-MM-DD HH:mm:ss')
        this.currentEditItem['fModifyTime'] = moment(
          this.currentEditItem['fModifyTime']
        ).format('YYYY-MM-DD HH:mm:ss')
        if (this.currentEditItem['fCreateTime'] == 'Invalid date') {
          this.currentEditItem['fCreateTime'] = ''
        }
        if (this.currentEditItem['fModifyTime'] == 'Invalid date') {
          this.currentEditItem['fModifyTime'] = ''
        }
        // console.log(this.currentEditItem, 'currentEditItem')
      }
      let or
      if (isNew) {
        or = this.canAdd
      } else {
        or = this.canEdit
      }
      const h = this.$createElement
      this.$formDlg({
        title: `${isNew ? '新增仓库' : '查看仓库'}`,
        width: '30%',
        formTpl: <editForm form={this.currentEditItem}></editForm>,
        formSubmit: (formData) => this.postData(isNew ? 0 : 1, formData),
        readonly: !or
      })
    },

    _delete(row) {
      this.postData(2, row)
    },

    // 修改角色
    postData(modifyType, data) {
      return this.$httpPost('Warehouse/Stock/StockModify', {
        datalist: JSON.stringify({
          modifyType: modifyType,
          info: data
        })
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },

    //    日期格式转换
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
